import { render, staticRenderFns } from "./LogoUploader.vue?vue&type=template&id=4a6a3778"
import script from "./LogoUploader.vue?vue&type=script&lang=ts"
export * from "./LogoUploader.vue?vue&type=script&lang=ts"
import style0 from "./LogoUploader.vue?vue&type=style&index=0&id=4a6a3778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports